var sampleCategories = [
  'Quantity',
  'Sold',
  'Magnitude',
  'Category with long name',
  'Budget',
  'Total volume',
  'Average %',
  'Another category with along name',
  'Misc',
  'Indicator',
  'KPI_1',
  'KPI_2',
  'Other Indicator',
  'GDP',
  'HDI',
  'GPI',
  'PQLI',
  'Spain',
  'France',
  'USA',
]
var sampleMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
]
var sampleLines = [
  'Line 1',
  'Line 2',
  'Line 3',
  'Line 4',
  'Line 5',
  'Line 6',
  'Line 7',
  'Line 8',
  'Line 9',
]
var sampleDimension = [
  'First Dimension',
  'Second Dimension',
  'Ohter Dimension',
  'Very long dimension Name',
  'Another long dimension name',
  'Yet another long dimension name',
  'dim_6',
  'dim_7',
  'dim_8',
  'dim_9',
]
var sampleLetters = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
]
const numDec = 2

export function sanitizeData(value) {
  let sanitized = value.map(row => {
    return row.map(cell => {
      if (cell === '' || cell === null || cell === undefined) return null
      else if (cell instanceof Date) return cell
      else if (
        (!isNaN(Number(cell)) || !isNaN(Number(String(cell).replace(',', '.')))) &&
        String(cell).replaceAll(' ', '') === String(cell)
      ) {
        return Number(String(cell).replace(',', '.'))
      } else return cell
    })
  })
  return sanitized
}

export function convertRowsToData(rows, dims = 1) {
  let headers = rows[0]
  // //si no lleva id, se lo metemos (haciendo copia)
  // if(headers[0]!=='id'){
  //   headers = ['id',...headers]
  //   rows = rows.map((r,index)=>[index,...r])
  // }
  let data = rows.slice(1).map(row => {
    let rowObject = { id: row[0] }
    if (headers.length > 2 || dims === 2) {
      rowObject.value = headers.slice(1).map((header, i) => {
        return {
          id: header,
          parentId: row[0],
          value: row[i + 1],
        }
      })
    } else {
      //SOLO cuando es "simple" podemso cambiar el nombre del "value"
      rowObject[headers[1]] = row[1]
    }
    return rowObject
  })
  // console.log("TO (d3)DATA FORMAT:")
  // console.log(data)
  return data
}
///////////////////////////////

export function makeRandomData(signed = true, size = 5) {
  let max
  let rowIds = sampleCategories.slice(0, size)
  if (Math.random() > 0.0) max = 100
  else max = 1
  let rows = rowIds.map(d => {
    return [d, +((signed ? -max / 2 : 0) + Math.random() * max).toFixed(numDec)]
  })
  // rows[0][1] = 1000+100*Math.random()
  return [['id', 'value']].concat(rows)
}

export function makeRandomData2D(signed = true, size = [5, 5]) {
  if (size.length != 2) {
    size = [5, 5]
  }
  let rowIds = sampleMonths.slice(0, size[0])
  let colIds = ['id'].concat(sampleCategories.slice(0, size[1]))
  let rows = rowIds.map(rowId => {
    return [
      rowId,
      ...[...Array(size[1]).keys()].map(() => {
        return +((signed ? -500 : 0) + Math.random() * 1000).toFixed(numDec)
      }),
    ]
  })
  return [colIds].concat(rows)
}

export function makeRandomData2DPercentage(signed = false, size = [5, 5]) {
  if (size.length != 2) {
    size = [5, 5]
  }
  let rowIds = sampleCategories.slice(0, size[0])
  let colIds = ['id'].concat(sampleLetters.slice(0, size[1]))
  let rows = rowIds.map(rowId => {
    return [
      rowId,
      ...[...Array(size[1]).keys()].map(() => {
        return +((signed ? -100 : 0) + Math.random() * 400).toFixed(numDec)
      }),
    ]
  })
  return [colIds].concat(rows)
}

export function makeRandomData2DLines(signed = true, size = [3, 8]) {
  if (size.length != 2) {
    size = [5, 5]
  }
  // let rowIds = [...Array(size[1]).keys()].map((i)=>new Date(`01-0${i+1}-2021`))
  let rowIds = [...Array(size[1]).keys()]
  let colIds = ['id'].concat(sampleLines.slice(0, size[0]))
  let rows = rowIds.map(rowId => {
    return [
      rowId,
      ...[...Array(size[0]).keys()].map(() => {
        return +((signed ? -500 : 0) + Math.random() * 1000).toFixed(numDec)
      }),
    ]
  })
  return [colIds].concat(rows)
}
// header: [id,x,y,group,size]
export function makeRandomDataScatter(signed = false, size = 10) {
  let colIds = ['id', 'x', 'y', 'group']

  let groups = Array.from(Array(Math.floor(1 + Math.random() * 5)).keys()).map(
    i => 'group_' + (i + 1)
  )
  let maxX = Math.random() > 0.5 ? 10 : 1000 //10
  let maxY = Math.random() > 0.5 ? 100 : 5 //10
  let maxSize = Math.random() > 0.5 ? 10 : 1000
  let rows = [...Array(size).keys()].map(d => {
    return [
      d < sampleCategories.length ? sampleCategories[d] : d,
      +((signed ? -maxX / 2 : 0) + Math.random() * maxX).toFixed(numDec),
      +((signed ? -maxY / 2 : 0) + Math.random() * maxY).toFixed(numDec),
      groups[Math.floor(Math.random() * groups.length)],
    ]
  })
  return [colIds].concat(rows)
}
export function makeRandomDataBubble(signed = false, size = 10) {
  let colIds = ['id', 'x', 'y', 'group', 'size']

  let groups = Array.from(Array(Math.floor(1 + Math.random() * 5)).keys()).map(
    i => 'group_' + (i + 1)
  )
  let maxX = Math.random() > 0.5 ? 10 : 1000 //10
  let maxY = Math.random() > 0.5 ? 100 : 5 //10
  let maxSize = Math.random() > 0.5 ? 10 : 1000
  let rows = [...Array(size).keys()].map(d => {
    return [
      d < sampleCategories.length ? sampleCategories[d] : d,
      +((signed ? -maxX / 2 : 0) + Math.random() * maxX).toFixed(numDec),
      +((signed ? -maxY / 2 : 0) + Math.random() * maxY).toFixed(numDec),
      groups[Math.floor(Math.random() * groups.length)],
      +(Math.random() * maxSize).toFixed(numDec),
    ]
  })
  return [colIds].concat(rows)
}

// header: [id,open,high,close,low]
export function makeRandomDataCandleStick(size = 10) {
  let colIds = ['id', 'open', 'close', 'high', 'low']
  let rows = [...Array(size).keys()].map(d => {
    let v = +(Math.random() * 50).toFixed(numDec)
    let o = v + +(-5 + Math.random() * 10).toFixed(numDec)
    let c = v + +(-5 + Math.random() * 10).toFixed(numDec)
    return [
      d,
      o, //Math.random()*50,
      c, //Math.random()*50,
      +(Math.max(o, c) + Math.random() * 10).toFixed(numDec), //Math.random()*50,
      +(Math.min(o, c) - Math.random() * 10).toFixed(numDec), //Math.random()*50,
      // value: Math.random()*500,
    ]
  })
  return [colIds].concat(rows)
}
// header: [id,x,y,color]
export function makeRandomDataHeatMap(size = [5, 5]) {
  if (size.length != 2) {
    size = [5, 5]
  }
  let colIds = ['x', 'y', 'color']
  let xs = sampleLetters.slice(0, size[0])
  let ys = sampleLetters.slice(0, size[1])
  let rows = []
  xs.forEach(x => {
    ys.forEach(y => {
      rows.push([
        // x+'_'+y,
        x,
        y,
        +Math.random().toFixed(numDec),
      ])
    })
  })
  return [colIds].concat(rows)
}

export function makeRandomDataChoropleth(features, featureIdProperty = 'id') {
  // return ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19'].map((d)=>{
  //   return {
  //     id: d,
  //     // cod_ccaa: d,
  //     value: Math.random()*100
  //   }
  // })
  let colIds = ['id', 'value']
  let rows = features.map(d => {
    return [
      d.properties[featureIdProperty],
      // adm1_code: d,
      +(Math.random() * 100).toFixed(numDec),
    ]
  })
  return [colIds].concat(rows)
}

export function makeRandomDataChoroplethCat(features, featureIdProperty = 'id') {
  // return ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19'].map((d)=>{
  //   return {
  //     id: d,
  //     // cod_ccaa: d,
  //     value: Math.random()*100
  //   }
  // })
  let categories = Array.from(Array(Math.floor(1 + Math.random() * 5)).keys()).map(
    i => 'category' + (i + 1)
  )
  let colIds = ['id', 'category']
  let rows = features.map(d => {
    return [
      d.properties[featureIdProperty],
      // adm1_code: d,
      categories[Math.floor(Math.random() * categories.length)],
    ]
  })
  return [colIds].concat(rows)
}

// header: [id,dim_0,dim_1,dim_2,dim_3,dim_4]
export function makeRandomDataParallelCoords(signed = false, size = [3, 5]) {
  if (size.length != 2) {
    size = [3, 5]
  }
  /*let colIds = ['id','a','b','c','d','e']
  let rows = ['Line 1','Line 2','Line 3'].map((d)=>{
    return [
      d,
      (signed?-200:0)+Math.random()*5,
      (signed?-500:0)+Math.random()*20,
      (signed?-500:0)+Math.random()*20,
      (signed?-5:0)+Math.random()*20,
      (signed?-500:0)+Math.random()*60,
    ]
  })
  return [colIds].concat(rows) */

  let colIds = ['id'].concat(sampleDimension.slice(0, size[1]))
  let rows = sampleLines.slice(0, size[0]).map(d => {
    return [d].concat(
      [...Array(size[1]).keys()].map(i => {
        return +((signed ? -100 : 0) + Math.random() * 100 + (i + 1) * Math.random()).toFixed(
          numDec
        )
      })
    )
  })
  return [colIds].concat(rows)
}

// header: [id,bar1,line1,line2]
export function makeRandomDataLineAndBarChart(signed = false, size = [1, 8]) {
  if (size.length != 2) {
    size = [1, 8]
  }

  let lines = [...Array(size[0]).keys()].map(i => 'line' + (i + 1))
  let colIds = ['id', 'bar1'].concat(lines)

  let max
  let rowIds = sampleCategories.slice(0, size[1])

  if (Math.random() > 0.0) max = 100
  else max = 1
  let rows = rowIds.map(d => {
    return [
      d,
      +((signed ? -max / 2 : 0) + Math.random() * max).toFixed(numDec),
      ...lines.map(() => +((signed ? -max / 2 : 0) + Math.random() * max).toFixed(numDec)),
    ]
  })
  return [colIds].concat(rows)
}

/////////////////////////////////////////////

export function transpose(data) {
  let ob = {}
  data.forEach(row => {
    row.value.forEach(col => {
      if (!ob[col.id]) ob[col.id] = { value: [], id: col.id }
      ob[col.id].value.push(col)
    })
  })
  let res = Object.keys(ob).map(key => {
    return { id: ob[key].id, value: ob[key].value }
  })
  return res
}
